module.exports = __webpack_public_path__ + "static/img/csdx.9b1fd2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/csdx.png
// module id = +zyG
// module chunks = 0